import {OwnerInfo} from 'ApplicationEntry/models/OwnerInfo';
import * as O from '../models/OwnerInfo';

import {PhoneNumber} from 'Core/models/PhoneNumber';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {ZipCode} from 'ApplicationEntry/models/ZipCode';

export enum OwnerInfoActionType {
  CHANGE_APPLICANT_IS_OWNER = 'ownerInfo/CHANGE_APPLICANT_IS_OWNER',
  CHANGE_OWNER_NAME = 'ownerInfo/CHANGE_OWNER_NAME',
  CHANGE_PHONE = 'ownerInfo/CHANGE_PHONE',
  CHANGE_DATE_OF_BIRTH = 'ownerInfo/CHANGE_DATE_OF_BIRTH',
  CHANGE_SOCIAL_SECURITY_NUMBER = 'ownerInfo/CHANGE_SOCIAL_SECURITY_NUMBER',
  CHANGE_SAME_ADDRESS_AS_APPLICANT = 'ownerInfo/CHANGE_SAME_ADDRESS_AS_APPLICANT',
  CHANGE_ADDRESS = 'ownerInfo/CHANGE_ADDRESS',
  CHANGE_ADDRESS_LINE2 = 'ownerInfo/CHANGE_ADDRESS_LINE2',
  CHANGE_CITY = 'ownerInfo/CHANGE_CITY',
  CHANGE_STATE = 'ownerInfo/CHANGE_STATE',
  CHANGE_ZIP = 'ownerInfo/CHANGE_ZIP',
  CHANGE_OWNER_SIGNED = 'ownerInfo/CHANGE_OWNER_SIGNED',
  CHANGE_IS_MAILING_ADDRESS = 'ownerInfo/CHANGE_IS_MAILING_ADDRESS',
}

export const isOwnerInfoAction = (action: any): action is OwnerInfoAction =>
  action.type in reverseEnum(OwnerInfoActionType);

export const changeApplicantIsOwner = (applicantIsOwner: boolean) =>
  createAction(OwnerInfoActionType.CHANGE_APPLICANT_IS_OWNER, {applicantIsOwner});
export const changeOwnerName = (ownerName: string) => createAction(OwnerInfoActionType.CHANGE_OWNER_NAME, {ownerName});
export const changePhone = (phone: PhoneNumber) => createAction(OwnerInfoActionType.CHANGE_PHONE, {phone});
export const changeDateOfBirth = (dateOfBirth: Date | '') =>
  createAction(OwnerInfoActionType.CHANGE_DATE_OF_BIRTH, {dateOfBirth});
export const changeSocialSecurityNumber = (socialSecurityNumber: string) =>
  createAction(OwnerInfoActionType.CHANGE_SOCIAL_SECURITY_NUMBER, {socialSecurityNumber});
export const changeSameAddressAsApplicant = (sameAddressAsApplicant: boolean) =>
  createAction(OwnerInfoActionType.CHANGE_SAME_ADDRESS_AS_APPLICANT, {sameAddressAsApplicant});
export const changeAddress = (address: string) => createAction(OwnerInfoActionType.CHANGE_ADDRESS, {address});
export const changeAddressLine2 = (addressLine2: string) =>
  createAction(OwnerInfoActionType.CHANGE_ADDRESS_LINE2, {addressLine2});
export const changeCity = (city: string) => createAction(OwnerInfoActionType.CHANGE_CITY, {city});
export const changeState = (state: string) => createAction(OwnerInfoActionType.CHANGE_STATE, {state});
export const changeZip = (zip: ZipCode) => createAction(OwnerInfoActionType.CHANGE_ZIP, {zip});
export const changeOwnerSigned = (ownerSigned: boolean) =>
  createAction(OwnerInfoActionType.CHANGE_OWNER_SIGNED, {ownerSigned});
export const changeIsMailingAddress = (isMailingAddress: boolean) =>
  createAction(OwnerInfoActionType.CHANGE_IS_MAILING_ADDRESS, {isMailingAddress});

export type OwnerInfoAction =
  | ReturnType<typeof changeApplicantIsOwner>
  | ReturnType<typeof changeOwnerName>
  | ReturnType<typeof changePhone>
  | ReturnType<typeof changeDateOfBirth>
  | ReturnType<typeof changeSocialSecurityNumber>
  | ReturnType<typeof changeSameAddressAsApplicant>
  | ReturnType<typeof changeAddress>
  | ReturnType<typeof changeAddressLine2>
  | ReturnType<typeof changeCity>
  | ReturnType<typeof changeState>
  | ReturnType<typeof changeZip>
  | ReturnType<typeof changeOwnerSigned>
  | ReturnType<typeof changeIsMailingAddress>;

type OwnerInfoState = OwnerInfo;

export default (state: OwnerInfoState, action: OwnerInfoAction) => {
  switch (action.type) {
    case OwnerInfoActionType.CHANGE_APPLICANT_IS_OWNER:
      return O.changeApplicantIsOwner(action.payload.applicantIsOwner)(state);
    case OwnerInfoActionType.CHANGE_OWNER_NAME:
      return O.changeOwnerName(action.payload.ownerName)(state);
    case OwnerInfoActionType.CHANGE_PHONE:
      return O.changePhone(action.payload.phone)(state);
    case OwnerInfoActionType.CHANGE_DATE_OF_BIRTH:
      return O.changeDateOfBirth(action.payload.dateOfBirth)(state);
    case OwnerInfoActionType.CHANGE_SOCIAL_SECURITY_NUMBER:
      return O.changeSocialSecurityNumber(action.payload.socialSecurityNumber)(state);
    case OwnerInfoActionType.CHANGE_SAME_ADDRESS_AS_APPLICANT:
      return O.changeSameAddressAsApplicant(action.payload.sameAddressAsApplicant)(state);
    case OwnerInfoActionType.CHANGE_ADDRESS:
      return O.changeAddress(action.payload.address)(state);
    case OwnerInfoActionType.CHANGE_ADDRESS_LINE2:
      return O.changeAddressLine2(action.payload.addressLine2)(state);
    case OwnerInfoActionType.CHANGE_CITY:
      return O.changeCity(action.payload.city)(state);
    case OwnerInfoActionType.CHANGE_STATE:
      return O.changeState(action.payload.state)(state);
    case OwnerInfoActionType.CHANGE_ZIP:
      return O.changeZip(action.payload.zip)(state);
    case OwnerInfoActionType.CHANGE_OWNER_SIGNED:
      return O.changeOwnerSigned(action.payload.ownerSigned)(state);
    case OwnerInfoActionType.CHANGE_IS_MAILING_ADDRESS:
      return O.changeIsMailingAddress(action.payload.isMailingAddress)(state);
    default:
      return state;
  }
};
